const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://marketluz.com/laravel8/public/api';

export const chargePayment = async (chargeData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/test-culqi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(chargeData),
    });

    if (!response.ok) {
      Console.log('Response:', response);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error processing charge:', error);
    throw error;
  }
};

export const validateToken = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/validate-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      throw new Error('Token validation failed');
    }

    return await response.json();
  } catch (error) {
    console.error('Error validating token:', error);
    throw error;
  }
};
